import { Button } from "@design-system/Button/Button";

/**
 * `Button` under a name the a11y lint does not treat as a labelled control:
 * a `Picker.Select` trigger has no children of its own because the root fills
 * its label from the selection at render time. Same component, same props;
 * use it only as a Picker `trigger`.
 */
export const PickerButton = Button;
